import { render } from "./patient_create_page.vue?vue&type=template&id=418460ff"
import script from "./patient_create_page.vue?vue&type=script&lang=js"
export * from "./patient_create_page.vue?vue&type=script&lang=js"

import "./patient_create_page.vue?vue&type=style&index=0&id=418460ff&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__